import type { SxProps, Theme } from '@mui/material';

// -- UsageReport page layout --

export const pageContainerSx: SxProps<Theme> = {
  bgcolor: '#f5f5f5',
  minHeight: '100vh',
  py: 4,
  pt: 12
};

export const contentWrapperSx: SxProps<Theme> = {
  mb: 4
};

export const titleBarSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 3
};

export const pageTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  color: '#333',
  mt: '20px'
};

export const downloadButtonSx: SxProps<Theme> = {
  mt: '20px'
};

export const errorAlertSx: SxProps<Theme> = {
  mb: 3
};

export const filtersPaperSx: SxProps<Theme> = {
  p: 3,
  mb: 3,
  bgcolor: 'white'
};

export const totalUsersBoxSx: SxProps<Theme> = {
  mb: 2
};

export const loadingContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  p: 4
};

export const tablePaperSx: SxProps<Theme> = {
  bgcolor: 'white',
  overflow: 'auto'
};

// -- Table --

export const tableSx: SxProps<Theme> = {
  minWidth: 700
};

export const emptyStateSx: SxProps<Theme> = {
  p: 4,
  textAlign: 'center'
};

export const headerRowSx: SxProps<Theme> = {
  bgcolor: '#f5f5f5'
};

export const headerCellSx: SxProps<Theme> = {
  fontWeight: 600,
  color: '#333',
  borderBottom: '2px solid #ddd'
};

export const bodyRowSx: SxProps<Theme> = {
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafafa'
  },
  '&:hover': {
    backgroundColor: '#f0f0f0'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
};

export const bodyCellSx: SxProps<Theme> = {
  py: 2
};

// -- Filters --

export const filterButtonSx: SxProps<Theme> = {
  height: '40px'
};
